var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "row p-4 text-center justify-content-around align-items-center",
    },
    [
      _c("h3", { staticClass: "col-12 mb-3 display-4" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._l(_vm.logos, function (logo) {
        return _c(
          "div",
          {
            key: logo.href,
            staticClass: "p-3 mt-2 mt-md-0 sponsor-logo-container",
          },
          [
            _c("a", { attrs: { href: logo.href, target: "_blank" } }, [
              _c("img", {
                class: logo.class,
                attrs: {
                  src: logo.src,
                  alt: logo.alt,
                  width: "280",
                  height: "120",
                },
              }),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }